import axios from "axios";

export class AuthResource {
    login(credentials) {
        return axios.post('/login', credentials);
    }

    requestForgottenPassword(email) {
        return axios.post('/forgot-password', {email});
    }

    resetPassword(email, password, password_confirmation, token) {
        return axios.post('/reset-password', {email, password, password_confirmation, token});
    }
}
